export default "__VITE_ASSET__BTC85zyj__"